export const contentTableConfig = {
  title: '访问记录',
  propList: [
    {
      prop: 'deptName',
      label: '部门名称',
      minWidth: '80',
      slotName: 'dept'
    },
    {
      prop: 'channelName',
      label: '直播间',
      minWidth: '120',
      slotName: 'channelName'
    },
    { prop: 'pv', label: '访问次数(pv)', minWidth: '80' },
    {
      prop: 'uv',
      label: '客户数量(uv)',
      minWidth: '80'
    },
    {
      prop: 'ip',
      label: 'ip数量',
      minWidth: '80'
    },
    {
      prop: 'duration',
      label: '访问总时长(min)',
      minWidth: '120',
      slotName: 'duration'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
